import React from "react";
import { Space } from "antd";
import { ComponentsHelper } from "../../../../core/services/ComponentHelper";
import { CEDRO_CUSTOMER_NAME } from "../../../../home/Consts";
import { CUE_SHEETS_WORK_SEARCHVIEW_STATE_KEY, DRAFT_AGREEMENT_ASSIGNEE_VIEW, DRAFT_AGREEMENTS_APPLICABLE_WORKS_STATE_KEY, DRAFT_AGREEMENTS_COMMENTS_STATE_KEY, DRAFT_SET_LISTS_WORK_STATE_KEY, SET_LISTS_WORK_SEARCHVIEW_STATE_KEY } from "../../../../membersportal/Consts";
import { ADMINISTERED_BY_IP_BASE_NUMBER_STATE_KEY, ADMINISTERED_BY_KEY, AGREEMENT_CARVEOUTS_KEY, AGREEMENT_CARVEOUTS_PRODUCT_NAME_STATE_KEY, AGREEMENT_DUPLICATE_KEY, AMOUNT_TO_ALLOCATE, APPLICABLE_WORK_NAME_STATE_KEY, APPLICABLE_WORKS_KEY, ARTIST_TYPE_STATE_KEY, ARTISTS_KEY, ASSIGNEE_NAME_NUMBER, CLAIMED_WORKS, COMPONENTS_KEY, CONTRIBUTOR_COMMENTS, CONTRIBUTORS_KEY, COPY_LEVY_PERCENTAGE, COPY_LICENCE_PERCENTAGE, CREATOR_RETAINED_MECHANICAL_SHARE, CREATOR_RETAINED_PER_SHARE, DATA_GRID_TABLE_FIELDS_EXPANDER, DISTRIBUTION_POOLS_KEY, DROPDOWN_INPUT, ECONOMIC_RIGHT, ECONOMIC_RIGHT_DESCRIPTION, EDITABLE_DATA_FIELDS_CONFIGURATION_GRID, EDITABLE_FIELDS, EDITABLE_FIELDS_GRID, EXCLUDE_POOLS, EXCLUDE_TERRITORIES, INCLUDE_POOLS, INCLUDE_TERRITORIES, INTEGER_PERCENTAGE_INPUT, IP_LICENSING_REPRESENTATION_KEY, IP_NAMES_KEY, IP_REPRESENTATION_KEY, IPI_NUMBER_STATE_KEY, MATCHING_REPERTOIRE_PRODUCT_NAME_STATE_KEY, MATCHING_REPERTOIRE_PRODUCTS_KEY, MATCHING_REPERTOIRE_WORK_NAME_STATE_KEY, MATCHING_REPERTOIRE_WORKS_KEY, MECHANICAL_SHARE, MECHANICAL_SHARE_TO_DISPLAY, NOMINAL_VALUE_PER_POINT, OPEN_PARENT, ORDER_GRID_FIELD_METADATA, PARENT_WORK_KEY, PERFORMING_SHARE, PERFORMING_SHARE_TO_DISPLAY, POOL_POOL_CODE_STATE_KEY, PRODUCT_CONTRIBUTOR_NAME_STATE_KEY, PRODUCT_CONTRIBUTORS_KEY, PRODUCT_PERFORMER_NAME_STATE_KEY, PRODUCT_PERFORMERS_KEY, PUBLISHER_RETAINED_MECHANICAL_SHARE, PUBLISHER_RETAINED_PER_SHARE, RELATION, SEARCH_VIEW, SEARCH_VIEW_DRAFT_AGREEMENTS, SEARCH_VIEW_IPS, SEARCH_VIEW_SUBJECTS, UPDATE_ACTION, USAGE_DETAILS_ROWS_ACTIONS, USAGE_DETAILS_ROWS_INBOUNDFEESINERROR, USAGE_DETAILS_ROWS_OUTBOUNDFEESINERROR, USAGE_DETAILS_ROWS_SECTION_KEY, USAGE_MAINTENANCE_GRIDS_VIEW_COMMENTS_STATE_KEY, WORK_CONTRIBUTOR_RELATIONSHIPS_STATE_KEY, WORK_SUBJECT_KEY, WORK_SUBJECT_STATE_KEY, MAGAZINE_LEVY_COPY_CRITERIA, MAGAZINE_METADATA_PRICE, MAGAZINE_METADATA_PUBLISHED, MAGAZINE_LEVY_COPY_CRITERIA_NAME_STATE_KEY, MAGAZINE_METADATA_PRICE_NAME_STATE_KEY, MAGAZINE_METADATA_PUBLISHED_NAME_STATE_KEY } from "../../../Consts";
import { EXTERNAL_SVG } from "../../../IconConsts";
import { RepertoireHelper } from "../../../services/RepertoireHelper";
import { DataSource } from "../../../types/DataSource";
import { IRepertoireField } from "../../../types/IRepertoireField";
import { isTableAction } from "../../../types/ITableAction";
import IconTextButton from "../../iconTextButton/IconTextButton";
import ShowMore from "../../showMore/ShowMore";
import TextDataInput from "../../textDataInput/TextDataInput";
import { IDataGridTableProps } from "../DataGridTable";
import { getDataInputType } from "./dataGridTableRenderUtils";
import DropdownDataInput from "../../dropdownDataInput/DropdownDataInput";
import { getLookupValues, mapUsageLookupKey } from "../../../../lookup/services/LookupHelpers";

export const getTableSections = (
        tableContentItem: any,
        index: number,
        props: IDataGridTableProps,
        renderRowAction: (item: any, field: IRepertoireField) => JSX.Element,
        renderFieldOptions: (field: IRepertoireField, item: any, index: number) => JSX.Element,
        changeTableData: (value: any, stateKey: string, objectKey: string, rowIndex: number, componentInstance?: string) => void,
        showSearchModal: (item: any, view: string, index?: number) => void,
        onClickOpen: (field: IRepertoireField, item: any) => void
    ): {sections: JSX.Element[], dependentSections: JSX.Element[]} => {
        const { 
            dataGridTableData,
            componentInstance,
            showRowNumber,
            showRowName,
            stateKey,
            agreementShareDisplayOptions,
            isReadOnly,
            shareDecimalsToDisplay,
            dataSource,
            isExpandable,
            customer,
            activeSetType,
            openInNewTab,
            showModal
        } = props;
            const sections: JSX.Element[] = [];
            const dependentSections: JSX.Element[] = [];

            let currentComponentInstance = componentInstance;
            if (componentInstance === SET_LISTS_WORK_SEARCHVIEW_STATE_KEY) {
                currentComponentInstance = DRAFT_SET_LISTS_WORK_STATE_KEY;
            }

            const isContributors = currentComponentInstance === CONTRIBUTORS_KEY;
            const isIpNames = currentComponentInstance === IP_NAMES_KEY;
            const isMatchingWorks = stateKey === MATCHING_REPERTOIRE_WORKS_KEY;
            const isMatchingProducts = stateKey === MATCHING_REPERTOIRE_PRODUCTS_KEY;
            const isCedroPools = customer === CEDRO_CUSTOMER_NAME && stateKey === DISTRIBUTION_POOLS_KEY;
            const isUsageDetails = stateKey === USAGE_DETAILS_ROWS_SECTION_KEY;
            const isIpRepresentation = stateKey === IP_REPRESENTATION_KEY;
            const isDraftAssignee = stateKey === DRAFT_AGREEMENT_ASSIGNEE_VIEW;
            const showAgreementShares = !!agreementShareDisplayOptions?.ShowAgreementShares;

            const allFields = dataGridTableData?.fields ?? [];

            const fieldsForCurrentInstance = allFields.filter(
            f => f.componentInstance && f.componentInstance === currentComponentInstance
            );
            const expanderFields = allFields.filter(
            f => f.componentInstance && f.componentInstance === DATA_GRID_TABLE_FIELDS_EXPANDER
            );
            const dependentFields = allFields.filter(
            f => f.componentInstance && f.componentInstance.startsWith(currentComponentInstance + '.')
            );
            const dependentFieldKey =
            dependentFields.length > 0 ? dependentFields[0].componentInstance.split('.')[1] : undefined;

            const expanderByName: Record<string, IRepertoireField> = Object.fromEntries(
            expanderFields.map(f => [f.name, f])
            );

            let filteredFields = fieldsForCurrentInstance.filter(x => !x.hidden);
            if ((isContributors || isIpNames) && activeSetType !== 'other') {
            filteredFields = filteredFields.filter(x => x.name !== INCLUDE_TERRITORIES && x.name !== EXCLUDE_TERRITORIES);
            }

            const getExpanderField = (name: string) => expanderByName[name];
            const hasDependentRows = !!dependentFieldKey;

            if (isContributors) {
            filteredFields = ComponentsHelper.orderFieldsBySpecificField(filteredFields as IRepertoireField[], ORDER_GRID_FIELD_METADATA)
                .filter(field => field.name !== UPDATE_ACTION);
            }


            if (showRowNumber && currentComponentInstance !== IP_LICENSING_REPRESENTATION_KEY) {
                if(!showRowName){
                    sections.splice(0, 0, <td key='rowNumber' className="rowNumber">
                    <div className="tableCell">
                        {index + 1}
                    </div>
                </td>);

                }else{
                    sections.splice(0, 0, <td key='rowNumber' className="rowNumber">
                        <div className="tableCell">
                            {index === 0 ? 'From IP': 'To IP'}
                        </div>
                    </td>);
                }
                
            }
            if (showRowName && !showRowNumber ) {
                sections.splice(0, 0, <td key='rowName' className="rowName">
                    <div className="tableCell">
                        
                    </div>
                </td>);
            }

            type RenderContext = {
                field: IRepertoireField;
                tableContentItem: any;
                index: number;
                props: IDataGridTableProps;
                flags: {
                    isContributors: boolean;
                    isIpNames: boolean;
                    isMatchingWorks: boolean;
                    isMatchingProducts: boolean;
                    isCedroPools: boolean;
                    isUsageDetails: boolean;
                    isIpRepresentation: boolean;
                    isDraftAssignee: boolean;
                    showAgreementShares: boolean;
                };
                helpers: {
                    changeTableData: any;
                    renderRowAction: any;
                    renderFieldOptions: any;
                    showSearchModal: any;
                    onClickOpen: any;
                    getExpanderField: (name: string) => IRepertoireField | undefined;
                };
            };

            type FieldRenderer = {
                when: (ctx: RenderContext) => boolean;
                render: (ctx: RenderContext) => JSX.Element;
            };

            const renderers: FieldRenderer[] = [
                {
                    when: ({ field, props }) => {
                        const { stateKey, dataSource } = props;
                        return (
                            (stateKey === CONTRIBUTORS_KEY && field.name === IPI_NUMBER_STATE_KEY) ||
                            (stateKey === ADMINISTERED_BY_KEY && field.name === ADMINISTERED_BY_IP_BASE_NUMBER_STATE_KEY) ||
                            (stateKey === APPLICABLE_WORKS_KEY && field.name === APPLICABLE_WORK_NAME_STATE_KEY) ||
                            (stateKey === AGREEMENT_CARVEOUTS_KEY && field.name === AGREEMENT_CARVEOUTS_PRODUCT_NAME_STATE_KEY) ||
                            (stateKey === PRODUCT_CONTRIBUTORS_KEY && field.name === PRODUCT_CONTRIBUTOR_NAME_STATE_KEY) ||
                            (stateKey === MAGAZINE_LEVY_COPY_CRITERIA && field.name === MAGAZINE_LEVY_COPY_CRITERIA_NAME_STATE_KEY) ||
                            (stateKey === MAGAZINE_METADATA_PRICE && field.name === MAGAZINE_METADATA_PRICE_NAME_STATE_KEY ) ||
                            (stateKey === MAGAZINE_METADATA_PUBLISHED && field.name === MAGAZINE_METADATA_PUBLISHED_NAME_STATE_KEY ) ||
                            (dataSource === DataSource.Intray && stateKey === ARTISTS_KEY && field.name === ARTIST_TYPE_STATE_KEY) ||
                            (dataSource === DataSource.Intray && stateKey === PRODUCT_PERFORMERS_KEY && field.name === PRODUCT_PERFORMER_NAME_STATE_KEY) ||
                            (stateKey === DRAFT_AGREEMENTS_APPLICABLE_WORKS_STATE_KEY && field.name === APPLICABLE_WORK_NAME_STATE_KEY)
                        );
                    },
                    render: ({ field, tableContentItem, index, helpers }) => 
                        helpers.renderFieldOptions(field, tableContentItem, index)
                },
                {
                    when: ({ field, flags }) => flags.isMatchingWorks && !isTableAction(field.fieldType),
                    render: ({ field, tableContentItem, index, props, helpers }) => {
                        if (field.name === MATCHING_REPERTOIRE_WORK_NAME_STATE_KEY) {
                            return helpers.renderFieldOptions(field, tableContentItem, index);
                        }
                        return (
                            <td key={field.name} className="td" title={field.data}>
                                {getDataInputType(helpers.changeTableData, props, tableContentItem[field.name], field.name, index, field.fieldType, false)}
                            </td>
                        );
                    }
                },
                {
                    when: ({ field, props }) => props.stateKey === WORK_SUBJECT_KEY && field.name === WORK_SUBJECT_STATE_KEY,
                    render: ({ field, tableContentItem, index, props, helpers }) => (
                        <td key={field.name} title={field.data}>
                            <div className="tableCell hasIcon" style={{ display: 'flex', alignItems: 'center', marginTop: '4px', paddingLeft: '4px' }}>
                                <TextDataInput
                                    value={tableContentItem[field.name].value}
                                    fieldName={field.name}
                                    changeData={(value, stateKey) => helpers.changeTableData(tableContentItem[field.name].value, field.name, field.data, index)}
                                    readOnly={true}
                                    isHidden={true}
                                />
                                <ShowMore
                                    options={!props.isReadOnly && [
                                        {
                                            text: helpers.getExpanderField("selectSubject")?.data,
                                            onClick: () => { helpers.showSearchModal(tableContentItem, SEARCH_VIEW_SUBJECTS) },
                                            icon: EXTERNAL_SVG
                                        }
                                    ]}
                                />
                            </div>
                        </td>
                    )
                },
                {
                    when: ({ field, flags }) => flags.isMatchingProducts && !isTableAction(field.fieldType),
                    render: ({ field, tableContentItem, index, props, helpers }) => {
                        if (field.name === MATCHING_REPERTOIRE_PRODUCT_NAME_STATE_KEY) {
                            return helpers.renderFieldOptions(field, tableContentItem, index);
                        }
                        return (
                            <td key={field.name} className="td" title={field.data}>
                                {getDataInputType(helpers.changeTableData, props, tableContentItem[field.name], field.name, index, field.fieldType, false)}
                            </td>
                        );
                    }
                },
                {
                    when: ({ field, flags }) => flags.isCedroPools && field.name === POOL_POOL_CODE_STATE_KEY,
                    render: ({ field, tableContentItem, index, props, helpers }) => (
                        <td key={field.name} title={field.data}>
                            {getDataInputType(helpers.changeTableData, props, tableContentItem[POOL_POOL_CODE_STATE_KEY], field.name, index, DROPDOWN_INPUT, false)}
                        </td>
                    )
                },
                {
                    when: ({ field, props, flags }) => {
                        const { stateKey } = props;
                        return (
                            (stateKey === CONTRIBUTORS_KEY && field.name === 'perfPercentage') ||
                            (stateKey === CONTRIBUTORS_KEY && field.name === 'mechPercentage') ||
                            ((flags.isDraftAssignee || stateKey === ADMINISTERED_BY_KEY) && field.name === 'performingShare') ||
                            (flags.isDraftAssignee && field.name === CREATOR_RETAINED_PER_SHARE) ||
                            (flags.isDraftAssignee && field.name === PUBLISHER_RETAINED_PER_SHARE) ||
                            (stateKey === ADMINISTERED_BY_KEY && field.name === CREATOR_RETAINED_PER_SHARE) ||
                            (stateKey === ADMINISTERED_BY_KEY && field.name === PUBLISHER_RETAINED_PER_SHARE) ||
                            ((flags.isDraftAssignee || stateKey === ADMINISTERED_BY_KEY) && field.name === 'mechanicalShare') ||
                            (flags.isDraftAssignee && field.name === CREATOR_RETAINED_MECHANICAL_SHARE) ||
                            (flags.isDraftAssignee && field.name === PUBLISHER_RETAINED_MECHANICAL_SHARE) ||
                            (stateKey === ADMINISTERED_BY_KEY && field.name === CREATOR_RETAINED_MECHANICAL_SHARE) ||
                            (stateKey === ADMINISTERED_BY_KEY && field.name === PUBLISHER_RETAINED_MECHANICAL_SHARE)
                        );
                    },
                    render: ({ field, tableContentItem, index, props, helpers }) => {
                        const fieldToDataKey: Record<string, string> = {
                            'perfPercentage': PERFORMING_SHARE_TO_DISPLAY,
                            'mechPercentage': MECHANICAL_SHARE_TO_DISPLAY,
                            'performingShare': PERFORMING_SHARE,
                            'mechanicalShare': MECHANICAL_SHARE,
                            [CREATOR_RETAINED_PER_SHARE]: CREATOR_RETAINED_PER_SHARE,
                            [PUBLISHER_RETAINED_PER_SHARE]: PUBLISHER_RETAINED_PER_SHARE,
                            [CREATOR_RETAINED_MECHANICAL_SHARE]: CREATOR_RETAINED_MECHANICAL_SHARE,
                            [PUBLISHER_RETAINED_MECHANICAL_SHARE]: PUBLISHER_RETAINED_MECHANICAL_SHARE,
                        };
                        
                        const dataKey = fieldToDataKey[field.name] || field.name;
                        
                        return (
                            <td key={field.name} className="td" title={field.data}>
                                {getDataInputType(helpers.changeTableData, props, tableContentItem[dataKey], field.name, index, INTEGER_PERCENTAGE_INPUT, false)}
                            </td>
                        );
                    }
                },
                {
                    when: ({ field, props }) => props.stateKey === CONTRIBUTORS_KEY && field.name === CONTRIBUTOR_COMMENTS,
                    render: ({ field, tableContentItem, helpers }) => (
                        <td key={field.name} className="td" title={field.data}>
                            <div className="contributor-comment">
                                <IconTextButton
                                    icon={"ms-Icon ms-Icon--Chat"}
                                    text={""}
                                    onClick={() => helpers.onClickOpen(field, tableContentItem)}
                                />
                            </div>
                        </td>
                    )
                },
                {
                    when: ({ field, props }) => props.stateKey === CONTRIBUTORS_KEY && field.name === RELATION,
                    render: ({ field, tableContentItem, index, props, helpers }) => (
                        <td key={field.name} className="td" title={field.data}>
                            {getDataInputType(helpers.changeTableData, props, tableContentItem[RELATION], field.name, index, field.fieldType, false)}
                        </td>
                    )
                },
                {
                    when: ({ field, props }) => {
                        const { stateKey } = props;
                        return (
                            (stateKey === USAGE_DETAILS_ROWS_SECTION_KEY && field.name === USAGE_DETAILS_ROWS_INBOUNDFEESINERROR) ||
                            (stateKey === USAGE_DETAILS_ROWS_SECTION_KEY && field.name === USAGE_DETAILS_ROWS_OUTBOUNDFEESINERROR) ||
                            (stateKey === USAGE_DETAILS_ROWS_SECTION_KEY && field.name === USAGE_DETAILS_ROWS_ACTIONS)
                        );
                    },
                    render: ({ field, tableContentItem, index, props, helpers }) => {
                        const isUsageRowActions = field.name === USAGE_DETAILS_ROWS_ACTIONS;

                                 let lookup;
                                    if (stateKey === USAGE_DETAILS_ROWS_SECTION_KEY) {
                                        lookup = mapUsageLookupKey(stateKey, tableContentItem[field.name]);
                                    }

                        let options;
                        options = getLookupValues(lookup, props.lookupValues, null, props.portalType)
                        options = options.map(option => ({...option, data: option.code, text: option.code}));
                        return (
                            !isUsageRowActions ? (<td key={field.name} className="td" title={field.data}>
                                <DropdownDataInput
                                                        value={tableContentItem[field.name]}
                                                        options={options}
                                                        changeData={(value, stateKey) => {
                                                            const updatedRow = { ...tableContentItem, [field.name]: value };
                                                            tableContentItem[field.name] = value;
                                                            const onUpdateUsageRowDetails = props.onUpdateUsageRowDetails;
                                                            onUpdateUsageRowDetails(updatedRow, field.name, index);
                                                        }
                                                        }
                                                        fieldName={field.name}
                                                        allowNull={true}
                                                        showDropdownsAsCodes={false}
                                                        readOnly={false}
                                                        isHidden={false}
                                                        customer={customer}
                                                    /> </td>) : <td key={field.name} className="td" title={field.data}>
                                 {getDataInputType(helpers.changeTableData, props, tableContentItem[field.name], field.name, index, field.fieldType, false)} 
                            </td>
                        );
                    }
                },
                {
                    when: ({ field, props }) => {
                        const { stateKey } = props;
                        return (
                            (stateKey === DISTRIBUTION_POOLS_KEY && field.name === AMOUNT_TO_ALLOCATE) ||
                            (stateKey === DISTRIBUTION_POOLS_KEY && field.name === NOMINAL_VALUE_PER_POINT)
                        );
                    },
                    render: ({ field, tableContentItem, index, props, helpers }) => (
                        <td key={field.name} className="td" title={field.data}>
                            {getDataInputType(helpers.changeTableData, props, tableContentItem[field.name], field.name, index, field.fieldType, false, null, 0)}
                        </td>
                    )
                },
                {
                    when: ({ field, props }) => {
                        const { stateKey } = props;
                        return (
                            (stateKey === CONTRIBUTORS_KEY && field.name === COPY_LEVY_PERCENTAGE) ||
                            (stateKey === CONTRIBUTORS_KEY && field.name === COPY_LICENCE_PERCENTAGE)
                        );
                    },
                    render: ({ field, tableContentItem, index, props, helpers }) => {
                        if (field.name === COPY_LEVY_PERCENTAGE) {
                            tableContentItem[COPY_LEVY_PERCENTAGE].value = RepertoireHelper.trailingZeroesForShares(tableContentItem[COPY_LEVY_PERCENTAGE].value, props.shareDecimalsToDisplay);
                        } else if (field.name === COPY_LICENCE_PERCENTAGE) {
                            tableContentItem[COPY_LICENCE_PERCENTAGE].value = RepertoireHelper.trailingZeroesForShares(tableContentItem[COPY_LICENCE_PERCENTAGE].value, props.shareDecimalsToDisplay);
                        }
                        
                        return (
                            <td key={field.name} className="td" title={field.data}>
                                {getDataInputType(helpers.changeTableData, props, tableContentItem[field.name], field.name, index, field.fieldType, false)}
                            </td>
                        );
                    }
                },
                {
                    when: ({ field, props }) => props.stateKey === AGREEMENT_DUPLICATE_KEY && field.name === "repertoireAgreementID",
                    render: ({ field, tableContentItem, index, props, helpers }) => (
                        <td key={field.name} title={field.data}>
                            <div className="tableCell hasIcon">
                                <TextDataInput
                                    value={tableContentItem[field.name].value}
                                    fieldName={field.name}
                                    changeData={(value, stateKey) => helpers.changeTableData(tableContentItem[field.name].value, field.name, field.data, index)}
                                    readOnly={true}
                                    isHidden={true}
                                />
                                <ShowMore
                                    options={!props.isReadOnly && [
                                        {
                                            text: helpers.getExpanderField("openAgreement")?.data,
                                            onClick: () => { props.openInNewTab(tableContentItem) },
                                            icon: EXTERNAL_SVG
                                        }
                                    ]}
                                />
                            </div>
                        </td>
                    )
                },
                {
                    when: ({ field, props }) => props.stateKey === DRAFT_AGREEMENTS_COMMENTS_STATE_KEY && field.name === "comment",
                    render: ({ field, tableContentItem, index, props, helpers }) => (
                        <td key={field.name} className="td">
                            <div style={{ position: 'relative', zIndex: 1000 }}>
                                <div style={{ position: 'absolute', display: 'flex', alignItems: 'center', right: -15, top: '50%', transform: 'translateY(-50%)' }}>
                                    <ShowMore
                                        options={[
                                            {
                                                text: dataGridTableData?.fields?.find(f => f.name === "expandComment")?.data || "Expand Comment",
                                                onClick: () => { helpers.showSearchModal(tableContentItem, SEARCH_VIEW_DRAFT_AGREEMENTS, index) },
                                                icon: EXTERNAL_SVG
                                            }
                                        ]}
                                    />
                                </div>
                                <div className="input-container">
                                    <TextDataInput
                                        value={tableContentItem[field.name].value}
                                        fieldName={field.name}
                                        changeData={(value, stateKey) => helpers.changeTableData(value, stateKey, field.name, index)}
                                        readOnly={props.isReadOnly}
                                        isHidden={false}
                                    />
                                </div>
                            </div>
                        </td>
                    )
                },
                {
                    when: ({ field, props }) => props.stateKey === USAGE_MAINTENANCE_GRIDS_VIEW_COMMENTS_STATE_KEY && field.name === "comment",
                    render: ({ field, tableContentItem, index, props, helpers }) => (
                        <td key={field.name} className="td">
                            <div style={{ position: 'relative', zIndex: 1000 }}>
                                <div style={{ position: 'absolute', display: 'flex', alignItems: 'center', right: -15, top: '50%', transform: 'translateY(-50%)' }}>
                                    <ShowMore
                                        options={[
                                            {
                                                text: dataGridTableData?.fields?.find(f => f.name === "expandComment")?.data || "Expand Comment",
                                                onClick: () => { helpers.showSearchModal(tableContentItem, SEARCH_VIEW_DRAFT_AGREEMENTS, index) },
                                                icon: EXTERNAL_SVG
                                            }
                                        ]}
                                    />
                                </div>
                                <div className="input-container">
                                    <TextDataInput
                                        value={tableContentItem[field.name].value}
                                        fieldName={field.name}
                                        changeData={(value, stateKey) => {
                                            helpers.changeTableData(value, stateKey, field.name, index)
                                        }}
                                        readOnly={props.isReadOnly}
                                        isHidden={false}
                                    />
                                </div>
                            </div>
                        </td>
                    )
                },
                {
                    when: ({ field, flags }) => flags.isDraftAssignee && field.name === ASSIGNEE_NAME_NUMBER,
                    render: ({ field, tableContentItem, index, props, helpers }) => (
                        <td key={field.name} className="td">
                            <div style={{ position: 'relative', zIndex: 1000 }}>
                                <div style={{ position: 'absolute', display: 'flex', alignItems: 'center', right: -15, top: '50%', transform: 'translateY(-50%)' }}>
                                    <ShowMore
                                        options={[
                                            {
                                                text: dataGridTableData?.fields?.find(f => f.name === "selectIP")?.data || "Select IP",
                                                onClick: () => { helpers.showSearchModal(SEARCH_VIEW, SEARCH_VIEW_IPS, index) },
                                                icon: EXTERNAL_SVG
                                            }
                                        ]}
                                    />
                                </div>
                                <div className="input-container">
                                    <TextDataInput
                                        value={tableContentItem[field.name].value}
                                        fieldName={field.name}
                                        changeData={(value, stateKey) => helpers.changeTableData(value, stateKey, field.name, index)}
                                        readOnly={true}
                                        isHidden={false}
                                    />
                                </div>
                            </div>
                        </td>
                    )
                },
                {
                    when: ({ field, props, flags, tableContentItem }) => {
                        const { stateKey } = props;
                        return (
                            ((flags.isIpRepresentation || (stateKey === CONTRIBUTORS_KEY && tableContentItem.setType == 'other')) && field.name === "includeTerritories") ||
                            ((flags.isIpRepresentation || (stateKey === CONTRIBUTORS_KEY && tableContentItem.setType == 'other')) && field.name === "excludeTerritories") ||
                            (flags.isIpRepresentation && field.name === INCLUDE_POOLS) ||
                            (flags.isIpRepresentation && field.name === EXCLUDE_POOLS)
                        );
                    },
                    render: ({ field, tableContentItem, index, helpers }) => 
                        helpers.renderFieldOptions(field, tableContentItem, index)
                },
                {
                    when: ({ field }) => isTableAction(field.fieldType),
                    render: ({ field, tableContentItem, helpers }) => helpers.renderRowAction(tableContentItem, field)
                },
                {
                    when: ({ field, props }) => props.stateKey === EDITABLE_FIELDS,
                    render: ({ field, tableContentItem, index, props, helpers }) => {
                        const nameField = tableContentItem["name"];
                        const item = {
                            value: tableContentItem["data"], 
                            inputType: field.fieldType, 
                            hidden: tableContentItem["hidden"] as boolean,
                            name: nameField, 
                            isReadOnly: false, 
                            defaultValue: tableContentItem["defaultValue"],
                            isMandatory: tableContentItem["isMandatory"], 
                            isMandatoryModifiable: tableContentItem["isMandatoryModifiable"],
                            isInTheBody: tableContentItem["isInTheBody"]
                        };
                        const disabled = field.name === "defaultValue" && (tableContentItem["fieldType"] === "dropdown" || tableContentItem["fieldType"] === "multiselect");
                        
                        return (
                            <td key={`${field.name}_${item["name"]}`} className="td col-lg-3 col-md-3 col-sm-3 col-xs-3" title={field.data}>
                                {getDataInputType(helpers.changeTableData, props, item, field.name, index,
                                    field.fieldType, tableContentItem["hidden"] as boolean,
                                    undefined, undefined, !disabled)}
                            </td>
                        );
                    }
                },
                {
                    when: ({ field, props }) => props.stateKey === EDITABLE_DATA_FIELDS_CONFIGURATION_GRID,
                    render: ({ field, tableContentItem, index, props, helpers }) => {
                        const nameField = tableContentItem["name"];
                        const item = {
                            value: tableContentItem["data"], 
                            inputType: field.fieldType, 
                            hidden: tableContentItem["hidden"] as boolean,
                            name: nameField, 
                            isReadOnly: false, 
                            defaultValue: tableContentItem["defaultValue"],
                            isMandatory: tableContentItem["isMandatory"], 
                            isMandatoryModifiable: tableContentItem["isMandatoryModifiable"],
                            isInTheBody: tableContentItem["isInTheBody"]
                        };
                        const disabled = field.name === "defaultValue" && (tableContentItem["fieldType"] === "dropdown" || tableContentItem["fieldType"] === "multiselect");
                        
                        return (
                            <td key={`${field.name}_${item["name"]}`} className="td col-lg-3 col-md-3 col-sm-3 col-xs-3" title={field.data}>
                                {getDataInputType(helpers.changeTableData, props, item, field.name, index,
                                    field.fieldType, tableContentItem["hidden"] as boolean,
                                    undefined, undefined, !disabled)}
                            </td>
                        );
                    }
                },
                {
                    when: ({ field, props }) => props.stateKey === CLAIMED_WORKS && field.name === 'workNumbers',
                    render: ({ field, tableContentItem }) => {
                        if (tableContentItem[field.name] instanceof Array) {
                            const elements = tableContentItem[field.name].map((claimWorkNumber: any, index: number) => {
                                return (
                                    <div className="m-1" key={`${index}_list`}><Space>{claimWorkNumber}</Space></div>
                                )
                            });
                            return <>{elements}</>;
                        }
                        return <td key={field.name} className="td" />;
                    }
                },
                {
                    when: ({ field }) =>
                        currentComponentInstance === CUE_SHEETS_WORK_SEARCHVIEW_STATE_KEY && field.name === "title",
                    render: ({ field, tableContentItem, props }) => {
                        const text = tableContentItem[field.name]?.value ?? tableContentItem[field.name] ?? "";
                        const workID = tableContentItem.workCode;

                        return (
                            <td key={field.name} className="td" title={field.data}>
                                <div className="tableCell">
                                    <a
                                        href="#"
                                        title="Open work in a new tab"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            if (!workID) return;
                                            props.getRegisteredWorkDetails?.(DataSource.Repertoire, Number(workID),props.lookupValues,props.registeredWorksMaintenanceGeneralDataViewData);
                                        }}
                                    >
                                        {text}
                                    </a>
                                </div>
                            </td>
                        );
                    }
                },
                {
                    when: ({ field, tableContentItem }) => tableContentItem[field.name] || tableContentItem[field.name] === '',
                    render: ({ field, tableContentItem, index, props, helpers }) => {
                        if (currentComponentInstance === COMPONENTS_KEY && field.name === 'duration') {
                            return (
                                <td key={field.name} className="td unableMinWidth" title={field.data}>
                                    {getDataInputType(helpers.changeTableData, props, tableContentItem[field.name], field.name, index, field.fieldType, false)}
                                </td>
                            );
                        } else if (currentComponentInstance === COMPONENTS_KEY && field.name === 'writer') {
                            return (
                                <td key={field.name} className="td" title={field.data}>
                                    {getDataInputType(helpers.changeTableData, props, tableContentItem[field.name], field.name, index, field.fieldType, false)}
                                </td>
                            );
                        } else {
                            let className = 'tableCell';
                            if (currentComponentInstance === 'productContributor' && (field.name === 'avRipRoleCode' || field.name === 'name')) {
                                className = `${className} minWidth`;
                            }
                            
                            return (
                                <td key={field.name} className={`td ${props.stateKey === CONTRIBUTORS_KEY && field.name === 'name' && 'extraWide'}`} title={field.data}>
                                    <div className={className}>
                                        {getDataInputType(helpers.changeTableData, props, tableContentItem[field.name], field.name, index, field.fieldType, false,
                                            field.name === ECONOMIC_RIGHT ? tableContentItem[ECONOMIC_RIGHT_DESCRIPTION] : undefined)}
                                    </div>
                                </td>
                            );
                        }
                    }
                },
                {
                    when: () => true,
                    render: ({ field }) => <td key={field.name} className="td" />
                }
            ];

            filteredFields.forEach((field) => {
                const ctx: RenderContext = {
                    field,
                    tableContentItem,
                    index,
                    props,
                    flags: {
                        isContributors,
                        isIpNames,
                        isMatchingWorks,
                        isMatchingProducts,
                        isCedroPools,
                        isUsageDetails,
                        isIpRepresentation,
                        isDraftAssignee,
                        showAgreementShares
                    },
                    helpers: {
                        changeTableData,
                        renderRowAction,
                        renderFieldOptions,
                        showSearchModal,
                        onClickOpen,
                        getExpanderField
                    }
                };

                const renderer = renderers.find(r => r.when(ctx));
                if (renderer) {
                    sections.push(renderer.render(ctx));
                }
            });

            if (hasDependentRows) {
                const items: any[] = tableContentItem[dependentFieldKey];
                if (items) {
                    let i: number = 0;
                    items.map(item => {
                        i++;
                        const rowCells: JSX.Element[] = [];
                        rowCells.push(<td key={i} className="td" />)
                        dependentFields.map(dependentField => {
                            const key: string = dependentFields[0].componentInstance + '.' + dependentField.name;
                            
                            let alignRight = false
                            if (dependentField) {
                                if (isTableAction(dependentField.fieldType)) {
                                    rowCells.push(renderRowAction(item, dependentField))
                                }
                                else {
                                    let cellData = item[dependentField.name];
                                    if (dependentField.name === 'ipiNumber')
                                        cellData = RepertoireHelper.zeroPaddedIPINameNumber(isNaN(Number(item['ipiNumber'])) ? "" : item[dependentField.name]);

                                    if (dependentField.name === 'perfPercentage' && agreementShareDisplayOptions != null && showAgreementShares) {
                                        cellData = RepertoireHelper.trailingZeroesForShares(item['performingShareToDisplay'], shareDecimalsToDisplay);
                                        alignRight = true;
                                    }
                                    else if (dependentField.name === 'mechPercentage' && agreementShareDisplayOptions != null && showAgreementShares) {
                                        cellData = RepertoireHelper.trailingZeroesForShares(item['mechanicalShareToDisplay'], shareDecimalsToDisplay);
                                        alignRight = true
                                    }

                                    if (dependentField.name === 'role' && item.agreementCategoryRoleCode != null) {
                                        cellData = item.agreementCategoryRoleCode;
                                    }

                                    rowCells.push(
                                        <td key={key} className={`td ${alignRight ? 'alignRight' : ''}`} title={dependentField.data}>
                                            {cellData}
                                        </td>
                                    );
                                }
                            }
                            else {
                                rowCells.push(<td key={key} className="td" />)
                            }
                        });

                        dependentSections.push(
                            <tr key={index + dependentFieldKey + i} className="tr dependent">
                                {rowCells}
                            </tr>
                        )
                    });
                }
            }

            return { sections, dependentSections };
        
    };